var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"bg-mesh"}),_c('app-confirm-dialog'),(_vm.$route.meta.layout === 'fullscreen')?_c('v-main',[_c('router-view')],1):_vm._e(),(_vm.$route.meta.layout === 'menu')?_c('app-layout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }